import React, {FunctionComponent, useEffect, useMemo, useState} from 'react';
import {uuidv4} from "@klear/common-utils";
import {useScript} from "../hooks/useScript.hook";
const recaptchaKeyV2 = '6LdK3_8UAAAAAIHEAnhVNnmi3MTKYcANf3NebTiW';

interface CaptchaV2Props {
    onVerify: (token: string) => void;
    onExpire: () => void;
    className?: string;
}

interface ResetCaptchaV2Props {

}

declare const grecaptcha: {
    render: (key: string, params: {sitekey: string, callback: any,'expired-callback': any }) => Promise<string>;
    reset: () => Promise<void>;
};

export const CaptchaV2: FunctionComponent<CaptchaV2Props> = props => {
    const {onVerify, onExpire, className} = props;
    const myId = useMemo(() => 'recaptcha_check_' + uuidv4(), []);
    useScript(`https://www.google.com/recaptcha/api.js?render=explicit`);
    useEffect(() => {
        grecaptcha.render(myId, {
            sitekey: recaptchaKeyV2,
                callback: onVerify,
            'expired-callback': onExpire
        });
    }, [onVerify, myId, onExpire]);
    return (
        <div id={myId} className={`${className}`}/>
    );
};